"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.german = void 0;
var types_1 = require("../types");
exports.german = {
    code: types_1.LocaleCode.German,
    facebook: 'de_DE',
    label: 'Deutsch',
    loadingText: 'Laden...',
    translations: {
        ar: 'Arabische',
        de: 'Deutsch',
        en: 'Englisch',
        es: 'Spanisch',
        fr: 'Französich',
        id: 'Indonesische',
        it: 'Italienisch',
        ja: 'Japanisch',
        ko: 'Koreanisch',
        lo: 'Laotische',
        ms: 'Malaiische',
        pt: 'Portugiesische',
        ru: 'Russisch',
        th: 'Thai',
        tl: 'Philippinische',
        tr: 'Türkische',
        vi: 'Vietnamesische',
        'zh-CN': '‪Chinesisch (Einf.)',
        'zh-TW': '‪Chinesisch (Trad.)'
    }
};
